import { PAYMENTSLINK } from '../actionTypes';
import CONSTANTS from '../constants';

const initialState = {
  content: [],
  paymentsLinkStatus: undefined,
  paymentsLinkError: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PAYMENTSLINK.FETCH:
      return {
        ...state,
        paymentsLinkStatus: CONSTANTS.API_STATUS.STARTED,
      };
    case PAYMENTSLINK.SUCCESS:
      return {
        ...state,
        ...action.payload,
        paymentsLinkStatus: CONSTANTS.API_STATUS.SUCCEEDED,
      };
    case PAYMENTSLINK.FAILED:
      return {
        ...state,
        paymentsLinkError: action.payload,
        paymentsLinkStatus: CONSTANTS.API_STATUS.FAILED,
      };
    default:
      return state;
  }
};
